module.exports = __webpack_public_path__ + "5ed574635b4baff14e63722f12bfcd20.ttf";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-SemiBoldItalic.ttf
// module id = 374
// module chunks = 0